import React, { useState, useEffect } from "react";
import { DoctorModal, HeaderComponent } from "../../FourthComponents";
import { doctorData } from "../../fourthUtils/constant";

const FourthDoctors = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [isHeaderFixed, setIsHeaderFixed] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImg, setModalImg] = useState(false);
    const [modalName, setModalName] = useState(false);
    const [modalRole, setModalRole] = useState(false);
    const [modalSpecialty, setModalSpecialty] = useState(false);
    const [modalSubSpecialty1, setModalSubSpecialty1] = useState(false);
    const [modalSubSpecialty2, setModalSubSpecialty2] = useState(false);
    const [modalAbout, setModalAbout] = useState(false);
    useEffect(() => {
        let lastScrollTop = 0;
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 40) {
                setIsHeaderFixed(true);
            } else {
                setIsHeaderFixed(false);
            }
            lastScrollTop = scrollTop;
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const showModal = (img, name, role, specialty, subSpecialty1, subSpecialty2, about) => {
        setIsModalOpen(true);
        setModalImg(img)
        setModalName(name)
        setModalRole(role)
        setModalSpecialty(specialty)
        setModalSubSpecialty1(subSpecialty1)
        setModalSubSpecialty2(subSpecialty2)
        setModalAbout(about)
    };
    return (
        <div className={isHeaderFixed ? "frth-design-screens-main" : ""}>
            <HeaderComponent title={selectedLanguage?.txt_our_doctors_team} />
            <div className="frth-des-doctors-main">
                {
                    doctorData?.map((v, i) => {
                        return (
                            <div>
                                <div className="frth-des-doctor-img-div">
                                    <div className="frth-des-overlay-img">
                                        <button onClick={() => showModal(
                                            v?.img,
                                            isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName),
                                            isELSelect ? v?.role : (isAlSelect ? v?.alRole : v?.glRole),
                                            isELSelect ? v?.specialty : (isAlSelect ? v?.alSpecialty : v?.glSpecialty),
                                            isELSelect ? v?.subSpecialty1 : (isAlSelect ? v?.alSubSpecialty1 : v?.glSubSpecialty1),
                                            isELSelect ? v?.subSpecialty2 : (isAlSelect ? v?.alSubSpecialty2 : v?.glSubSpecialty2),
                                            isELSelect ? v?.about : (isAlSelect ? v?.alAbout : v?.glAbout)
                                        )}>
                                        </button>
                                    </div>
                                    <img src={v?.img} alt="" />
                                </div>
                                <div>
                                    <h2>
                                        {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                    </h2>
                                    <p>
                                        {isELSelect ? v?.role : (isAlSelect ? v?.alRole : v?.glRole)}
                                    </p>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <DoctorModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} modalImg={modalImg} modalName={modalName} modalRole={modalRole} modalSpecialty={modalSpecialty} modalSubSpecialty1={modalSubSpecialty1} modalSubSpecialty2={modalSubSpecialty2} modalAbout={modalAbout} {...props} />
        </div>
    )
}
export default FourthDoctors
